import axios from 'axios';

export const uploadNewImages = async (images, path) => {
  /*Images Configs*/
  let imgsConfigs = [];
  try {
    for (let imgIndx = 0; imgIndx < images.length; imgIndx++) {
      imgsConfigs.push(
        await axios.get('/api/upload/img', {
          params: { path }
        })
      );
    }
  } catch (err) {
    return { error: 'Error in uploading image config', imgsConfigs };
  }

  /*Upload Images to AWS*/
  try {
    for (let Index = 0; Index < imgsConfigs.length; Index++) {
      await axios.put(imgsConfigs[Index].data.url, images[Index], {
        headers: {
          'Content-Type': images[Index].type
        }
      });
    }
    return { error: '', imgsConfigs };
  } catch (err) {
    return { error: 'Error in Uploading the image to AWS', imgsConfigs };
  }
};

export const delete_images = async images_urls => {
  try {
    await axios.post('/api/delete/image', {
      images_urls
    });
    return { error: '' };
  } catch (err) {
    return { error: 'Error in deleting image from AWS' };
  }
};
